<script>
    import { fade } from "svelte/transition";
    import { Route } from "svelte-router-spa";
    export let currentRoute;
    export let params = {};

    const clickLogo = () => {
        location.href = "https://www.groovworks.com/";
    };
</script>

<div class="wrap" in:fade>
    <header class="header">
        <div class="inner">
            <div
                data-collapse="small"
                data-animation="default"
                data-duration="400"
                data-easing="ease"
                data-easing2="ease"
                data-doc-height="1"
                role="banner"
                class="avatalk-menu w-nav"
            >
                <div class="avatalk-logo">
                    <a href="/" class="avatalk-link"></a>
                </div>
            </div>
            <img
                class="logo-icon pointer"
                src="/static/images/logo.svg"
                on:click={clickLogo}
            />
        </div>
    </header>
    <Route {currentRoute} {params} />
</div>

<style>
    .logo-icon {
        z-index: 1000;
    }
    .header {
        display: flex;
        align-items: center;
    }

    @media screen and (max-width: 500px) {
        .logo-icon {
            display: none !important;
        }
    }
</style>
